import React, { useState } from 'react';
import styled from 'styled-components';
import { ACCENT_COLOR, NAME_SECTION, PADDING, FONTSIZETITLE } from '../styles/style';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Masonry from 'react-masonry-css';
import iconWebsite from '../images/icon-website.png';
import { useMemo } from 'react';

const Section = styled.section`
  /* height: auto; */
  
  background-color: #212529;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  position: relative;
  ${PADDING};
`;

const AnimatedText = styled(motion.div)`
  width: 100%;
  max-width: 1300px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  flex-direction: column;

  .title {
    position: relative;
    color: white;
    width: 100%;
    ${FONTSIZETITLE};
    &::after {
      color: #ffffff60 !important;
      content: "PORTFOLIO";
      ${NAME_SECTION};
      @media(max-width:767px){font-size:3rem;};
      width: 100%;
    }
  }

  .category-buttons {
    display: flex;
        flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap:10px 24px;
    margin-top: 40px;
    z-index:2;
    button {
      background: none;
      border: none;
      font-size: 1rem;
      color: #ffffff99;
      font-family: Poppins;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      padding: 4px 8px;

      &.active {
        color: ${ACCENT_COLOR};
      }
    }
  }

  .my-masonry-grid {
    display: flex;
    margin-left: -24px;
    width: auto;
    padding-top: 60px;
  }

  .my-masonry-grid_column {
    padding-left: 24px;
    background-clip: padding-box;
  }

  .my-masonry-grid_column > div {
    margin-bottom: 24px;
  }

  .gallery-item {
    border-radius: 3px;
    overflow: hidden;
    position: relative;
    
    .project{
      position: relative;
      text-decoration: none;
      &:hover img{
        scale:1.05;
        transition: .2s all ease;
        filter: grayscale(100%) opacity(.4);
      }
      &:hover .info-project{
        transition: .2s all ease;
        visibility: visible;
      }
      small{
        position: absolute;
        z-index: 3;

        color:white;
        text-align: center;
        /* visibility: hidden; */
        font-size: .75rem;
        line-height: 1rem;
        @media(min-width:768px){
          font-size: 1rem;
        line-height: 1.2rem;
        }
        width: 100%;
        font-weight: 100;
        display: flex;
        margin-top:10px;
      }
      .info-project{
        z-index: 999;
        position: absolute;
        width: 300px;
        left:0%;
        top:50%;
        transform: translate(-50%, -50%);
        font-size: 1.5rem;
        font-weight: 700;
        color:white;
        visibility: hidden;
        z-index: 1;
        line-height: 2rem;
      }
    }
    img {
      transition: .2s all ease;
      width: 100%; height: 100%;
      display: block;
      height: auto;
      object-fit: cover;
      border-radius: 3px;
      background-position: center center;
      margin-bottom: 5px;
    }
  }
`;

const Portfolio = () => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
      const options = useMemo(() => ({
      triggerOnce: true,
      threshold: isMobile ? 0.1 : 0.2,
      rootMargin: isMobile ? '-60px 0px 0px 0px' : '-100px 0px 0px 0px',
    }), []);
    
    const [ref, inView] = useInView(options);
  const [selectedCategory, setSelectedCategory] = useState('Wszystkie');
  const images = require.context('../images/portfolio', false, /\.jpg$/);

  const getImageUrl = (name) => {
    try {
      return images(`./${name}.jpg`);
    } catch (e) {
      console.error(`Image not found: ${name}`);
      return null;
    }
  };

  const items = [
  { id: 1, category: 'Strony internetowe', name: 'budujfinanse', url: "https://budujfinanse.pl", desc: "Realizacja bloga - (Wordpress) Gutenberg + ACF" },
  { id: 2, category: 'Aplikacje', name: 'budzet360', url: "https://budzet360.pl", desc: "Aplikacja do zarządzania budżetem domowym" },
  { id: 3, category: 'Strony internetowe', name: 'magazyny maxkuchnie', url: "https://www.maxkuchnie.pl/magazyn/", desc: "Realizacja strony internetowej przy użyciu HTML, CSS, JS" },
  { id: 4, category: 'Strony internetowe', name: 'brooklyncorpenergy', url: "https://brooklyncorpenergy.com", desc: "Realizacja strony internetowej przy użyciu WordPress + Elementor" },
  { id: 5, category: 'Strony internetowe', name: 'builtup', url: "https://builtup.pl", desc: "Realizacja strony internetowej przy użyciu WordPress + Elementor + ACF" },
  { id: 6, category: 'Strony internetowe', name: 'pergole builtup', url: "https://pergole.builtup.pl", desc: "Realizacja strony internetowej przy użyciu WordPress + Elementor" },
  { id: 7, category: 'Strony internetowe', name: 'domkimorzeniechorze', url: "https://domkimorzeniechorze.pl", desc: "Realizacja strony internetowej przy użyciu WordPress + Elementor" },
  { id: 8, category: 'Strony internetowe', name: 'kulinarne podroze', url: "https://maxkuchnie.pl/kulinarne-podroze/", desc: "Realizacja strony internetowej przy użyciu WordPress + Elementor + ACF z ograniczoną ilością pluginów" },
  { id: 9, category: 'Strony internetowe', name: 'midnightstereo', url: "https://midnightstereo.com", desc: "Realizacja strony internetowej przy użyciu WordPress + Elementor" },
  { id: 10, category: 'Strony internetowe', name: 'techwizemarketing', url: "https://techwizemarketing.io", desc: "Realizacja strony wizytówkowej przy użyciu WordPress + Elementor" },
  { id: 11, category: 'Strony internetowe', name: 'pergolove', url: "https://pergolove.eu", desc: "Tworzenie podstron przy użyciu WordPress + Elementor" },
  // { id: 9, category: 'Landing page', name: 'black week kernau', url: "https://www.kernau.com/promocje/black-weeks.html", desc: "Tworzenie landing page promocyjnego dla Kernau z użyciem technologii React + Fetch Api" },
  // { id: 10, category: 'Landing page', name: 'kernau linia copper', url: "https://www.kernau.com/linia-copper.html?gad_source=1&gad_campaignid=20542444932&gbraid=0AAAAACE3UjmmKS7N3RDZXBPbMMOnoqJBW&gclid=CjwKCAjwl_XBBhAUEiwAWK2hzshFw0OgL3DhWLOOC21vBJvwJRTnNcJPy-ads4QmPo7crmBYuzfTChoCWp4QAvD_BwE", desc: "Realizacja Landing page dla Kernau w HTML, CSS, JavaScript"},
  // { id: 11, category: 'Landing page', name: 'kernau linia gold', url: "https://www.kernau.com/linia-gold.html?gad_source=1&gad_campaignid=20542444932&gbraid=0AAAAACE3UjmmKS7N3RDZXBPbMMOnoqJBW&gclid=CjwKCAjwl_XBBhAUEiwAWK2hzr0tdVNpTMpYAiGpEi0g5imZTZ6Q9YbT5PvOfEHtx1kIRqlwVv-JhRoCzIIQAvD_BwE", desc: "Realizacja Landing page dla Kernau w HTML, CSS, JavaScript"},
  { id: 12, category: 'Administracja', name: 'afinia', url: "https://www.afinia.pl", desc: "Administracja sklepu internetowego, dbanie o bezpieczeństwo oraz poprawne funkcjonowanie sklepu. Tworzenie kart produktowych i wdrażanie dedykowanych rozwiązań."},
  { id: 13, category: 'Administracja', name: 'afinia italy', url: "https://www.afinia.it", desc: "Administracja sklepu internetowego, dbanie o bezpieczeństwo oraz poprawne funkcjonowanie sklepu. Tworzenie kart produktowych i wdrażanie dedykowanych rozwiązań." },
  { id: 14, category: 'Administracja', name: 'innerharmony', url: "https://innerharmony.pl/", desc: "Administracja sklepu internetowego, aktualizacje sytemowe oraz dbanie o poprawne funkcjonowanie sklepu. Wdrażanie dedykowanych rozwiązań." },
  { id: 15, category: 'Administracja', name: 'grywan', url: "https://grywan.com/", desc: "Administracja sklepu internetowego, aktualizacje sytemowe oraz dbanie o poprawne funkcjonowanie sklepu. Wdrażanie dedykowanych rozwiązań." }
].map(item => ({
  ...item,
  imageUrl: getImageUrl(item.name)
}));

  const categories = ['Wszystkie', 'Strony internetowe', 'Landing page', 'Administracja', 'Aplikacje'];
  const filteredItems = selectedCategory === 'Wszystkie'
    ? items
    : items.filter(item => item.category === selectedCategory);

  const breakpointColumnsObj = {
    default: 3,
    1100: 2,
    700: 1,
  };

  return (
    <Section id="portfolio" ref={ref}>
  <AnimatedText 
    initial={{ opacity: 0 }}
    animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 1.2, ease: 'easeOut' }}
      >
        <div className="title">
          <h2>Moje projekty</h2>
        </div>

        <div className="category-buttons">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={selectedCategory === cat ? 'active' : ''}
            >
              {cat}
            </button>
          ))}
        </div>

        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {filteredItems.map(item => (
            <motion.div
              key={item.id}
              className="gallery-item"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, ease: 'easeOut' }}
            >
              {item.imageUrl && (
                <a className='project' href={item.url} target='_blank'>
                  <img
                    src={item.imageUrl}
                    alt={item.name}
                    onLoad={() => window.dispatchEvent(new Event('resize'))}
                  />
                  <div className='info-project'>
                  <p>{item.name}</p>
                  <small>{item.desc}</small>
                  </div>
                </a>
              )}

            </motion.div>
          ))}
        </Masonry>
      </AnimatedText>
    </Section>
  );
};

export default Portfolio;
